<template>
	<div class="footer-content">
		<div class="top">
			<div class="link">
                <div class="dls">
                    <dl>
                        <dt>产品</dt>
                        <dd v-for="(item,index) in productList" :key="index" @click="enterProductDetail(item)">
                            {{item.name}}
                        </dd>
                    </dl>
                    <dl>
                        <dt>支持与服务</dt>
                        <dd @click="enterService">在线客服</dd>
                        <dd @click="enterService">常见问题与解决方案</dd>
                    </dl>
                    <dl>
                        <dt>友情链接</dt>
                        <dd>
                            <div class="link_logo">
                                <img src="../../assets/common/qiyuesuo.png" alt="" @click="enterLink">
                            </div>
                        </dd>
                    </dl>
                    <dl class="right_dl">
                        <dt>关注我们</dt>
                        <dd>
                            <div class="picture">
                                <img src="../../assets/common/wxgzh.jpg" alt="">
                            </div>
                        </dd>
                    </dl>
                </div>
			</div>
		</div>
        <div class="relation">
            <div class="relation_title">
                <router-link to="/register/argeement" target="_blank">法律声明及隐私权限政策</router-link>
            </div>
            <div class="down" @click="openUrl()" style="cursor: pointer;">
                <div class="info">
				© 2021-2030 ropewaycloud.com 版权所有 武汉三特索道科技有限公司 鄂ICP备2021022516号-2
			    </div>
			    <div class="phone">
			    	联系电话：027-87883378
			    </div>
            </div>
        </div>
	</div>
</template>

<script>
import { queryProductByType } from '@/api/channel/product.js'
export default {
    data() {
        return {
            productList: [],
        }
    },
    created() {
        this.getData();
    },
    methods: {
        openUrl(){
            window.open('https://beian.miit.gov.cn/')
        },
        getData() {
            //查询产品列表
            let type = 0;
            queryProductByType(type).then(res => {
                this.productList = res.data.list;
            })
        },
        //进入产品详情页
        enterProductDetail(item) {
            this.$router.push({path: '/productDetail', query: {id: item.id}})
        }, 
        //进入支持与服务页面
        enterService() {
            this.$router.push({path: '/commonProblem'})
        },
        //进入契约锁页面
        enterLink() {
            window.open("https://www.qiyuesuo.com/",'_blank')
            // window.location.href = "www.baidu.com";
        }
    }
}
</script>

<style lang="scss" scoped="scoped">
.footer-content {
    // height: 150px;
    padding: 0 12%;
    background-color: #162045;
    color: #fff;
    .top {
        display: flex;
        justify-content: space-between;
        .link {
            min-width: 500px;
            width: 100%;
            .dls {
                display: flex;
                width: 100%;
                margin-bottom: 20px;
                dl {
                    margin-right: 150px;
                    dt {
                        margin: 30px 0;
                        font-size: 20px;
                    }
                    dd {
                        margin-inline-start: 0;
                        margin-bottom: 25px;
                        font-size: 14px;
                        color: #CCC;
                        .link_logo {
                            width: 107px;
                            height: 33px;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                            img:hover {
                                cursor: pointer;
                            }
                        }
                    }
                    dd:hover {
                        color: #fff;
                        cursor: pointer;
                    }
                }
                .right_dl {
                    margin-left: auto;
                    margin-right: 0;
                    .picture {
                        width: 153px;
                        height: 153px;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .picture:hover {
                        cursor: default;
                    }
                }
            }
        }
    }
    .relation {
       .relation_title {
            padding-bottom: 15px;
            margin-bottom: 15px;
            border-bottom: 1px solid #fff;
            a {
                font-size: 16px;
                color: #fff;
            }
       } 
       .down {
            display: flex;
            justify-content: space-between;
            padding-bottom: 20px;
            font-size: 14px;
        }
    }
    
}
</style>